<template>
  <vjs-modal v-bind="$options.propsData"
             :name="name"
             :title="title"
             :icon="icon">
    <b-form-group label="Template name:" label-for="template-name">
      <input id="template-name" v-model="template_name"
             v-validate="'required|min:2|max:191'"
             name="Template Name"
             class="form-control"
             type="text">
      <p v-show="errors.has('Template Name', 'template_form')" class="validation-error help kt-font-danger">
        {{ errors.first('Template Name', 'template_form') }}
      </p>
    </b-form-group>
    <template slot="body-controls">
      <div class="form-group d-flex justify-content-around">
        <button type="button" class="btn btn-ss-standout" @click="() => validateAndComplete(true)">
          Submit
        </button>
        <button type="button" class="btn btn-ss-cancel" @click="() => validateAndComplete(false)">
          Cancel
        </button>
      </div>
    </template>
  </vjs-modal>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue';

import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  components: {
    BFormGroup,
  },
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: 'save-as-template',
    },
    title: {
      type: String,
      required: false,
      default: 'New Template Name:',
    },
    icon: {
      type: String,
      required: false,
      default: 'flaticon2-writing',
    },
  },
  data: () => ({
    template_name: null,
  }),
  methods: {
    /**
     * Override submit callback so that we can trigger v-validate
     * @returns {Promise<void>}
     */
    async validateAndComplete(success) {
      this.close_data.success = success;
      this.close_data.name = this.template_name;
      if (success) {
        this.$validator.validateAll('template_form').then((result) => {
          if (result) {
            this.complete();
          }
        });
      } else {
        this.complete();
      }
    },
  },
};
</script>
